import { ImportService } from '@/service'
import Model from './Model'

export interface IImportSkoolMembers {
  externalGroupSlug: string
  email: string
  password: string
}

export interface IImportSkoolPosts {
  referenceAuditLogId: string
}

export enum SyncType {
  POST = 'post',
  COMMENT = 'comment',
  SKOOL_MEMBERS = 'skool-members',
  SKOOL_SYNC_MEMBERS = 'skool-sync-members',
  SKOOL_POSTS = 'skool-posts',
}

export enum SyncStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  IN_PROGRESS = 'in-progress',
}

export interface IImport {
  _id: string
  createdAt: Date
  updatedAt: Date
  syncId?: string
  status: SyncStatus
  errorLogs: string[]
  syncType: SyncType
  metadata: {
    csvUrl?: string
    externalGroupSlug?: string
    email?: string
    password?: string
  }
  totalDocuments: number
  syncedDocuments: number
}

export default class Imports extends Model {
  constructor(payload: IImport) {
    super(payload, ImportService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }
}
